var Config = {};

Config.ERFP_ATTACHMENT =  {
  fileTypes : "jpg,png,txt,pdf",
  fileCount : 5,
  maxSize : 3,
  unit : 'mb',
  maxSizeInBytes : 0,
  uploadedFilesSizeInBytes : 0,
  uploadedFilesCount : 0
}
module.exports = Config;